export type GenerateInvoicePayload = {
  folioId: string;
  reservationId: string;
  stayId: string;
  guestId: string;
  totalAmount: number;
  currency: string;
  emailInvoice: boolean;
  printInvoice: boolean;
};

export type GenerateInvoiceResult = {
  provider: string;
  documentId: string;
};

export interface FrontDeskInvoiceProvider {
  generateInvoice(payload: GenerateInvoicePayload): Promise<GenerateInvoiceResult>;
}

export class InMemoryFrontDeskInvoiceProvider implements FrontDeskInvoiceProvider {
  readonly provider = "in-memory-invoice";
  readonly generatedPayloads: GenerateInvoicePayload[] = [];

  async generateInvoice(payload: GenerateInvoicePayload): Promise<GenerateInvoiceResult> {
    this.generatedPayloads.push(payload);
    return {
      provider: this.provider,
      documentId: `inv-${this.generatedPayloads.length.toString().padStart(4, "0")}`,
    };
  }
}

